import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './Header.scss';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    if (location.pathname !== '/') {
      setActiveSection(null);
      return;
    }

    const onScroll = () => {
      const about = document.getElementById('about');
      const exhibitions = document.getElementById('exhibitions');
      const featured = document.getElementById('featured');
      const y = window.scrollY;

      if (about && y >= about.offsetTop - 120) {
        setActiveSection('about');
      } else if (exhibitions && y >= exhibitions.offsetTop - 120) {
        setActiveSection('exhibitions');
      } else if (featured && y >= featured.offsetTop - 120) {
        setActiveSection('featured');
      } else {
        setActiveSection(null);
      }
    };

    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  const handleScroll = (id) => {
    const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    if (location.pathname === '/') {
      scroll();
    } else {
      navigate('/');
      setTimeout(scroll, 100);
    }
  };

  return (
    <header>
      <Link to='/' className='artist-name'>Anna Hovan</Link>
      <nav>
        <Link to='/' className={location.pathname === '/' && !activeSection ? 'active' : ''}>Home</Link>
        <Link to='/works' className={location.pathname.startsWith('/works') ? 'active' : ''}>Works</Link>
        <Link to='/gallery' className={location.pathname.startsWith('/gallery') ? 'active' : ''}>3D Gallery</Link>
        <button className={`nav-about${activeSection === 'featured' ? ' active' : ''}`} onClick={() => handleScroll('featured')}>Featured</button>
        <button className={`nav-about${activeSection === 'exhibitions' ? ' active' : ''}`} onClick={() => handleScroll('exhibitions')}>Exhibitions</button>
        <button className={`nav-about${activeSection === 'about' ? ' active' : ''}`} onClick={() => handleScroll('about')}>About</button>
      </nav>
    </header>
  );
}

export default Header;
